var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M15.5 8v-.5a4 4 0 0 0-8 0V8a7.002 7.002 0 0 0 2.8 5.6 2.001 2.001 0 0 0 2.4 0A7.002 7.002 0 0 0 15.5 8zm-1.532 4.371.309 1.236a2.002 2.002 0 0 0 1.046 1.305l1.531.765a3.998 3.998 0 0 1 2.092 2.608L19.5 20.5h-16l.554-2.215a3.998 3.998 0 0 1 2.092-2.608l1.531-.765a2.002 2.002 0 0 0 1.046-1.305l.309-1.236",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgAvatar as ReactComponent };
export default __webpack_public_path__ + "c8e2c6c4161b52a76b8070f18558dd43.svg";